module.exports = __webpack_public_path__ + "img/s4-4.fa5cf69e.svg";